<template>
  <div class="upload-container">
    <div v-if="type == 'image'" class="image-container">
      <el-upload
          v-if="!isShowImage"
          ref="upload"
          v-model:file-list="fileList"
          list-type="picture-card"
          :action="FILE_URL"
          :on-remove="handleRemove"
          :name="name"
          :limit="limit"
          :on-change="handleChange"
          :on-success="handleSuccess"
          :on-exceed="handleExceed"
          :on-preview="handlePictureCardPreview"
          :disabled="isShowImage"
          :before-upload="beforeUpload"
          accept="image/*"
          :multiple="limit > 1"
          :show-file-list="limit > 1"
      >
        <div v-if="imageUrl && imageUrl.length > 0" style="width: 100%;height: 100%;position: relative"
             @mouseenter="showOverlay = true"
             @mouseleave="showOverlay = false"
        >

          <el-image
              ref="imageRef"
              style="width: 100%;height: 100%"
              :src="imageUrl"
              :preview-src-list="[imageUrl]"
              class="avatar"
              :preview-teleported="true"
              fit="contain"
          />

          <div
              v-show="showOverlay"
              class="overlay"
              :style="{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              opacity: 0.9 // 透明度可调
            }"
          >

            <el-button type="warning" :icon="Search" circle style="width: 30px;height:30px;margin: 15px"
            @click.stop="showBigPicture($event)"
            />
            <el-button type="danger" :icon="Delete" circle style="width: 30px;height:30px;margin: 15px"
            @click.stop="deletePicture"
            />
          </div>


        </div>

        <el-icon v-else class="avatar-uploader-icon">
          <Plus/>
        </el-icon>
      </el-upload>

      <div v-else class="image-list">
        <!-- @click="handlePictureCardPreview(item)" -->
        <el-image
            v-for="(item, index) in fileList"
            :preview-src-list="_fileList"
            :hide-on-click-modal="true"
            :initial-index="index"
            :key="item.url"
            :src="item.url"
            class="avatar"
            fit="cover"
        >

          <template
              #toolbar="{ actions, reset, activeIndex, setActiveItem }"
          >
            <el-icon @click="actions('zoomOut')">
              <ZoomOut/>
            </el-icon>
            <el-icon
                @click="actions('zoomIn', { enableTransition: false, zoomRate: 2 })"
            >
              <ZoomIn/>
            </el-icon>
            <el-icon
                @click="
            actions('clockwise', { rotateDeg: 180, enableTransition: false })
          "
            >
              <RefreshRight/>
            </el-icon>
            <el-icon @click="actions('anticlockwise')">
              <RefreshLeft/>
            </el-icon>
            <el-icon @click="reset">
              <Refresh/>
            </el-icon>
            <!--           <el-icon @click="handleEdit(fileList[activeIndex])"><Edit  /></el-icon>-->
          </template>
          <!-- 插槽在test.md中 -->
        </el-image>
      </div>
      <!-- 添加图片编辑器组件 -->
      <ImageEditor
          v-model="showEditor"
          :image-url="currentEditImage"
          @save="handleSaveEdit"
      />

      <div class="tip" v-if="limit == 1">
        仅支持上传<span class="red">jpg、png、jepg、bmp、SVG</span>格式的图片
      </div>
    </div>
    <div v-else-if="type == 'file'" class="file-container">
      <el-upload
          class="upload-demo"
          :action="FILE_URL"
          :name="name"
          :on-change="handleChange"
          :on-success="handleSuccess"
          :on-exceed="handleExceed"
          multiple
          :limit="3"
          v-model:file-list="fileList"
      >
        <el-button type="primary">{{ buttonText }}</el-button>
        <!-- <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，且不超过500kb
        </div> -->
      </el-upload>
    </div>
  </div>

  <!--  <el-dialog v-model="dialogVisible">
      <el-image :src="dialogImageUrl" alt="Preview Image" style="width: 100%"/>
    </el-dialog>-->

  <el-dialog title="图片编辑" v-model="showCanvas" style="border-radius: 20px;width: 1250px;">
    <div style="height: 1000px;width: 1200px;overflow-y: scroll;text-align: center;">
      <canvas ref="canvas" width="800px" @mousedown="mousedown" @mousemove="mousemove"
              @mouseup="mouseup"></canvas>
    </div>
    <div class="btn_box" style="margin-top: 20px">
      <div style="height: 35px;display: flex;align-items: center;">
          <span>
            <el-tooltip placement="top" content="设置马赛克的程度,数值越大越迷糊">
              <span class="blueFont">
                <svg-icon icon-class="question" style="font-size: 14px;cursor: pointer;"></svg-icon>
              </span>
            </el-tooltip>
            马赛克程度：
          </span>
        <el-input-number v-model="stepNum" controls-position="right" @change="handleChange" :min="1"
                         :max="50"></el-input-number>
      </div>
      <div style="height: 100%;flex: 1;display: flex;align-items: flex-end;justify-content: flex-end;">
        <el-button v-if="isPedometer > 0" type="primary" plain style="width: 90px;margin-right: 15px;"
                   @click="undoHandle()">撤销
        </el-button>
        <el-tooltip class="item" v-if="isPedometer === 0" effect="dark" content="当前没有需要撤销的操作"
                    placement="top-end">
          <el-button type="warning" plain style="width: 90px;margin-right: 15px;">撤销</el-button>
        </el-tooltip>
        <el-button type="danger" plain style="width: 90px;margin-right: 15px;"
                   @click="cancelHandle()">取消
        </el-button>
        <el-button type="primary" style="width: 90px" @click="saveMosaicImg()">确定</el-button>
      </div>
    </div>
  </el-dialog>

</template>
<script setup>
import {ElMessage} from "element-plus";
import {nextTick, onMounted, ref, watch, computed} from "vue";
import ImageEditor from "./imageEditor/index.vue";
import Compressorjs from "compressorjs";
import {
  Back,
  DArrowRight, Delete,
  Download, Edit,
  Refresh,
  RefreshLeft,
  RefreshRight,
  Right, Search,
  ZoomIn,
  ZoomOut
} from "@element-plus/icons-vue";
import {downLoadImage, uploadBase64} from "@/api/Upload";

const props = defineProps({
  modelValue: {
    default: () => "",
    type: Array || String,
  },
  // 模式 1:string,string 2:string[]
  mode: {
    default: 2,
    type: Number,
  },
  limit: {
    default: 1,
    type: Number,
  },
  name: {
    default: "uploadFile",
    type: String,
  },
  isShowImage: {
    default: false,
    type: Boolean,
  },
  // 区分图片和文件
  type: {
    default: "image",
    type: String,
  },
  // 上传文件的按钮名字
  buttonText: {
    default: "上传图片",
    type: String,
  },
});
const imageRef = ref(null);
const showBigPicture = (event)=>{
  event.stopPropagation();
  imageRef.value.showPreview()

}
const deletePicture=()=>{
  imageUrl.value= "";
  emit("update:modelValue", imageUrl.value);
}

const _fileList = computed(() => {
  return fileList.value.map((item) => {
    return item.url;
  });
});

const emit = defineEmits(["update:modelValue"]);
const FILE_URL = "/file/uploadFile";
const fileList = ref([]);
const handleRemove = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles);
  handleEmit();
};
const handleExceed = () => {
  ElMessage({
    message: "超出上传数量限制",
    type: "error",
  });
};
const showEditor = ref(false);
const showOverlay = ref(false);
// 修改编辑处理函数
const currentEditImage = ref("");
const handleEdit = (item) => {
  console.log("item", item.url);
  currentEditImage.value = item.url;
  showEditor.value = true;
};

const handleSaveEdit = (imageData) => {
  console.log(imageData, "imageData");
};
watch(
    () => props.modelValue,
    () => {
      handleInit();
    }
);
const handleInit = () => {
  let v = props.modelValue;
  let arr = [];

  if (props.mode == 1) {
    if (v == null || v == undefined) {
      v = "";
    }
    arr = v.split(",");
  } else {
    console.log(2222);

    if (v == null || v == undefined) {
      v = [];
    }
    arr = v;
  }
  if (arr && props.limit > 1) {
    arr = arr.filter((item) => {
      return item;
    });
    fileList.value = arr.map((item) => {
      return {
        url: item,
        name: item,
      };
    });
  } else {
    imageUrl.value = arr;
  }
};

/**
 * 处理
 */
const handleEmit = () => {
  nextTick(() => {
    let value = null;
    if (props.limit > 1) {
      value = fileList.value
          .filter((item) => {
            return item.status == "success" || !item.status;
          })
          .map((item) => {
            return item.response ? item.response.entity.fileUrl : item.url;
          });
      if (props.mode == 1) {
        value = value.join(",");
      }
    } else {
      value = value = imageUrl.value;
    }
    console.log(value);
    emit("update:modelValue", value);
  });
};
const imageUrl = ref("");
const handleSuccess = (response, file, fileList) => {
  console.log("handleSuccess:", response, file, fileList);
  if (props.limit == 1) {
    imageUrl.value = response.entity.fileUrl;
    handleEmit();
    return;
  }

  console.log(fileList.map((item) => item));
  let len = fileList
      .map((item) => {
        return item.status ? item.status : "success";
      })
      .filter((item) => {
        return item == "success";
      }).length;
  if (len == fileList.length) {
    handleEmit();
  }
};

const beforeUpload = async (file) => {
  console.log(file, "fielfllfelel");
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    ElMessage.error("只能上传图片文件!");
    return;
  }
  try {
    const compressedFile = await handlerCompressorjs(file);
    return compressedFile;
  } catch (e) {
    ElMessage.error("图片压缩失败");
    return false;
  }
};

const handlerCompressorjs = (file) => {
  return new Promise((resolve, reject) => {
    new Compressorjs(file, {
      quality: 0.4,
      // 所有图片都压缩
      convertTypes: [
        "image/png",
        "image/webp",
        "image/jpeg",
        "image/gif",
        "image/svg+xml",
        "image/gif",
      ],
      convertSize: 2 * 1024 * 1024,
      success: (compressedFile) => {
        resolve(compressedFile);
      },
      error: (e) => {
        console.log("压缩失败");
        console.log(e);
        reject(e);
      },
    });
  });
};

// const handleChange = () => {
//   console.log("change[=================]");
//   handleEmit();
// }
onMounted(() => {
  console.log("[upload image]");
  console.log(props.modelValue);
  handleInit();
});

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const handlePictureCardPreview = (uploadFile) => {
  console.log("打开了");
  console.log("item", uploadFile);
  console.log("item", uploadFile.url);
  /*  currentEditImage.value = uploadFile.url;
    showEditor.value = true;*/

  downLoadImage({path: uploadFile.url}).then(res => {
    watchUrl(res.entity.url, uploadFile);
  })


};

// 计算limit 如果等于1的话就false 反之就返回limit
const limit = computed(() => {
  return props.limit == 1 ? false : props.limit;
});

//


const showCanvas = ref(false);
const start = ref(false);
const mosaicHistory = ref([]);
const historyObj = ref({});
const isPedometer = ref(0); //撤销操作时使用
const stepNum = ref(30); //计步器，设置马赛克值

const upfile = ref(null);
const upurl = ref(null);
//
//
const canvas = ref(null);
const ctx = ref(null);
//


const watchUrl = async (url, uploadFile) => {
  showCanvas.value = true;
  isPedometer.value = 0;
  historyObj.value = {};
  upfile.value = uploadFile;
  upurl.value = url;

  await nextTick(() => {
    const img = new Image();
    //img.src = "http://localhost:8080/upload/3b4e482f-f8ac-4d7a-844e-d14d3dd1e3cd.jpg"
    img.src = url;
    // img.src = this.imgInfo.imgUrl;
    // img.setAttribute('crossOrigin', 'anonymous'); //防止canvas跨域获取不到图片信息

    img.onload = () => {
      const canvasEl = canvas.value;
      let width = 1000;
      let height = img.height * width / img.width;
      canvasEl.width = width;
      canvasEl.height = height;
      ctx.value = canvasEl.getContext("2d");
      ctx.value.drawImage(img, 0, 0, width, height);
    };
  });
}

// 鼠标按下开始绘制马赛克
const mousedown = () => {
  mosaicHistory.value = [];
  isPedometer.value++;
  start.value = true;
};
// 鼠标移动 绘制马赛克
const mousemove = (e) => {
  if (start.value) {
    const canvasEl = canvas.value;
    ctx.value = canvasEl.getContext("2d");
    ctx.value.willReadFrequently = true; // 优化提示，告诉浏览器计划频繁地读取画布上的数据，不然下面一行会送上警告
    let imgData = ctx.value.getImageData(0, 0, canvasEl.clientWidth, canvasEl.clientHeight);
    mosaicHistory.value.push(imgData); // 历史记录
    let num = stepNum.value; // //马赛克的程度，数值越大越模糊，数值越大马赛克高度越高
    let color = getXYColor(imgData, e.offsetX, e.offsetY); // 获取鼠标当前所在位置的像素RGBA
    // let color = ['128', '128', '128', '128']; // 也可以自己设定色值，注意：自己设定时每部分的取值都是 0 - 255
    for (let h = 0; h < num; h++) {
      for (let w = 0; w < num; w++) {
        setXYColor(imgData, e.offsetX + w, e.offsetY + h,
            color); //设置imgData上坐标为（e.offsetX + w, e.offsetY + h）的颜色
      }
    }
    ctx.value.putImageData(imgData, 0, 0); //更新canvas数据
  }
};
const getXYColor = (obj, x, y) => {
  // obj 也就是 imgData， 是图片的相关宽高以及每个坐标点的rgba色值四个色值，一个点位的色值占四个位置
  // y * canvas.width + x 计算当前像素在像素数组中的索引
  // * 4 是因为每个像素有四个部分（RGBA），每个部分是一个字节（0-255），所以我们需要乘以4来获取R值的索引。
  let w = obj.width;
  let color = [];
  color[0] = obj.data[4 * (y * w + x)];
  color[1] = obj.data[4 * (y * w + x) + 1];
  color[2] = obj.data[4 * (y * w + x) + 2];
  color[3] = obj.data[4 * (y * w + x) + 3];
  return color;
};
const setXYColor = (obj, x, y, color) => {
  let w = obj.width;
  obj.data[4 * (y * w + x)] = color[0];
  obj.data[4 * (y * w + x) + 1] = color[1];
  obj.data[4 * (y * w + x) + 2] = color[2];
  obj.data[4 * (y * w + x) + 3] = color[3];

};
// 鼠标抬起 马赛克绘制结束
const mouseup = () => {
  //this.$set(historyObj.value, isPedometer.value, mosaicHistory.value);
  start.value = false;
};
// 取消
const cancelHandle = () => {
  isPedometer.value = 0;
  historyObj.value = {};
  start.value = false;
  showCanvas.value = false;
  upfile.value = null;
  upurl.value = null;
};

// 确定
const saveMosaicImg = () => {
  let tempSrc = canvas.value.toDataURL('image/png');
  console.log("tempSrc", tempSrc);
  let formDatas = new FormData();
  dataURLtoFile(tempSrc) //此方法作用是将base64格式的图片转为文件格式之后方便再次上传到后端（若不需要上传可直接返回tempSrc即可展示）
};
const dataURLtoFile = (dataurl) => { //将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
  uploadBase64({base64: dataurl}).then(res => {
    console.log(res)
    //fileList.value.push({name: res.entity.fileName, url: res.entity.fileUrl})
    if (upfile.value) {
      fileList.value.forEach(item => {
        if (item.name == upfile.value.name) {
          item.url = res.entity.fileUrl
        }
      })
    }


    handleEmit();
    cancelHandle();

  });
  // 调用组件接口，将打马赛克的图片传递过去
};

// 撤销操作
const undoHandle = () => {
  delete historyObj.value[isPedometer.value];
  isPedometer.value--;

  ctx.value.willReadFrequently = true;
  if (Object.keys(historyObj.value).length > 0) {
    let newArr = [];
    Object.keys(historyObj.value).forEach(key => {
      newArr = [...newArr, ...historyObj.value[key]];
    })
    let lastState = newArr.pop();
    ctx.value.putImageData(lastState, 0, 0);
  } else {
    watchUrl(upurl.value, upfile.value); //如果长度等于0，说明没有绘制的马赛克了，重新加载canvas
  }
};

</script>
<style scoped lang="scss">
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.image-list {
  width: 100%;
  display: grid;
  // 平均分布
  grid-template-columns: repeat(auto-fill, minmax(178px, 1fr));
  grid-template-rows: 178px;
  grid-gap: 10px;

  .avatar {
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
.upload-container {
  display: flex;

  .image-container {
    width: 100%;
  }
}

.avatar {
  width: 100%;
  height: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

.el-upload.is-disabled {
  display: none;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  color: #999999;

  .red {
    color: #f56c6c;
  }
}

// 图片预览
:deep(.el-image-viewer__close) {
  font-size: 40px;
  height: 50px;
  width: 50px;
}

:deep(.el-image-viewer__next) {
  height: 50px;
  width: 50px;
  font-size: 40px;
}

:deep(.el-image-viewer__prev) {
  height: 50px;
  width: 50px;
  font-size: 40px;
}

// 底部按钮
:deep(.el-image-viewer__actions) {
  height: 60px;
  width: 350px;
/*  transform: rotate(90deg);*/
  right: -35px;
  /*left: auto;
  bottom: 200px;*/

  .el-image-viewer__actions__inner {
    font-size: 30px;
  }
}
</style>
